module.exports = __webpack_public_path__ + "static/shield-b43218b7352479b4a562a262986bb7a5.png";